import react, {useEffect, useState} from "react";
import useToken from './useToken';




import { Link } from 'react-router-dom';


export default function Accounts(){
    const token = useToken();
    const[accounts, setAccounts] = useState([]);

    useEffect(()=>{
        const URL = process.env.NODE_ENV === 'development'?process.env.REACT_APP_API_URL_DEV_MODE + 'api/accounts/': process.env.REACT_APP_API_URL_PROD_MODE + 'api/accounts/';
        
        fetch(URL, {headers: {"Authorization" :  `Token ${token}`}})
        .then((res)=> res.json())
        .then(data => {
            console.log(data);
            setAccounts(oldData => [...accounts, ...data]);
            console.log(accounts);
        })
        .catch(error=> console.log(error))
    }, []);

    if(!accounts){
        console.log("Account is null");
        return null;
    }

    // Now return accounts JSX
    return (<div className="account-card-container">
                {accounts.map(accountObj=>(
                    <div className="accountCard">
                        
                        
                            <div className="cardHeader"><Link to={`/contacts/${accountObj.id}/`}>  {accountObj.name} </Link></div>
                            {/*
                            <div className="cardContent">Total Prospects</div>
                            <div className="cardFooter">This is some footer</div>
                            */}


                        
                    </div>
                ))}
            </div>
        );
        

}
